import useTemplatePage from '@hooks/useTemplatePage'
import { UseAgencyMarketingPayload } from '@hooks/useAgencyMarketing'

import ListItemImageCover from '@components/ListItemImageCover'

import type { TemplatePageModel } from '@domain-group/realhub-backend-api-types'

interface TemplatePageProps {
  agencyMarketingPayload: UseAgencyMarketingPayload,
  serviceProductId: number,
  templatePage: TemplatePageModel,
}

const TemplatePage = (props: TemplatePageProps) => {
  const { agencyMarketingPayload, serviceProductId, templatePage } = props

  const { callbacks: { findCategoryId, createAgencyMarketingOrder } } = agencyMarketingPayload

  const templatePagePayload = useTemplatePage(templatePage)
  const {
    templatePage: {
      id,
      preview_image,
      title,
    },
  } = templatePagePayload

  const categoryId = findCategoryId(templatePage)

  return (
    <ListItemImageCover
      callbacks={{
        action: () => createAgencyMarketingOrder({ categoryId, serviceProductId, templatePage }),
      }}
      imageProps={{ backgroundSize: 'contain' }}
      // @ts-expect-error TS2322
      imageUrl={preview_image}
      secondaryTitle={`Template #${id}`}
      title={title}
    />
  )
}

export default TemplatePage
